import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  ButtonBase,
  Dialog,
  DialogContent,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrow from "@mui/icons-material/PlayArrow";
import CorrectIcon from "../images/correct.svg";
import useScreenRecorder from "../hooks/useScreenRecorder";
import PopUp from "../Components/Popup";
import Portal from "./Portal";

const Timer = ({ status }) => {
  const [time, setTime] = useState(0);

  useEffect(() => {
    let interval;
    if (status === "recording") {
      interval = setInterval(() => {
        setTime((prevTime) => {
          return prevTime + 1;
        });
      }, 1000);
    } else if (status === "paused" || status === "stopped") {
      clearInterval(interval);
    }

    return () => {
      return clearInterval(interval);
    };
  }, [status]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? "0" : ""}${minutes}:${
      seconds < 10 ? "0" : ""
    }${seconds}`;
  };

  return (
    <div style={{ color: "white", fontSize: "13px", marginRight: "5px" }}>
      {formatTime(time)}
    </div>
  );
};

export const ScreenRecorder = ({
  profileData,
  setShowRecordModal,
  showRecordModal,
  setShowFloat,
  parentStyle,
  consumerId,
  isInsideChatbot,
  setIsSdkRecording,
  setEmailAttachment,
  isEmail,
  handleSendEmail
}) => {
  const {
    startRecording,
    pauseRecording,
    blobUrl,
    resumeRecording,
    stopRecording,
    status
  } = useScreenRecorder({ audio: true });
  const videoRef = useRef();
  const [openCanvaModal, setopenCanvaModal] = useState(true);

  useEffect(() => {
    if(isInsideChatbot && blobUrl) {
      setEmailAttachment(
        {
          screenRecord: {
            filename: "recording.webm",
            content: blobUrl
          }
        }
      );
    }
  }, [blobUrl, isInsideChatbot])

  const handleClose = () => {
    if(isInsideChatbot) setIsSdkRecording(false)
    setShowFloat(true);
    setShowRecordModal(false);
  };

  const handlecloseRecord = () => {
    setShowFloat(true);
    setShowRecordModal(false);
    setopenCanvaModal(false);
    stopRecording();
    if(isInsideChatbot) {
      setIsSdkRecording(false);
    }
  };

  const handleRecord = () => {
    setShowFloat(true);
    setShowRecordModal(false);
    setopenCanvaModal(true);
    stopRecording();
    if(isInsideChatbot) {
      setIsSdkRecording(false);
    }
  };

  const handleStartRecording = () => {
    if(isInsideChatbot) {
      setIsSdkRecording(true);
    }
    startRecording();
  }
  
  return (
    <Portal parentStyle={parentStyle} portalId="bottom-buttons-portal">
    <div>
      {blobUrl && (
        <PopUp
          profileData={profileData}
          handleSave={() => {}}
          openCanvaModal={openCanvaModal}
          setCanvaOpenModal={setopenCanvaModal}
          setFormSubmit={() => {}}
          videoRef={videoRef}
          blobUrl={blobUrl}
          consumerId={consumerId}
          isEmail={isEmail}
          handleSendEmail={handleSendEmail}
        />
      )}

      <div
        style={{
          position: "fixed",
          left: "50%",
          bottom: "50px",
          transform: "translateX(-50%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "fit-content",
          gap: "10px",
          ...parentStyle.customIndex
        }}
      >
        {(status === "idle" ||
          status === "permission-requested" ||
          status === "error") &&
          showRecordModal === true && (
            <div
              style={{
                background: "#211f3c",
                borderRadius: "14px",
                padding: "2px 0 2px 8px"
              }}
            >
              <Button
                variant='contained'
                onClick={handleStartRecording}
                sx={{
                  fontSize: "10px",
                  height: "26px",
                  background: "#0568bf",
                  margin: "0 10px 0 0"
                }}
              >
                Start recording
              </Button>
              <IconButton onClick={handleClose}>
                <CloseIcon
                  sx={{
                    color: "white",
                    background: "#991402",
                    borderRadius: "7px"
                  }}
                />
              </IconButton>
            </div>
          )}
        {(status === "recording" || status === "paused") &&
          showRecordModal === true && (
            <div
              style={{
                background: "#211f3c",
                borderRadius: "14px",
                padding: "2px 3px 2px 8px",
                display: "flex",
                alignItems: "center"
              }}
            >
              <ButtonBase
                onClick={() => {
                  return status === "paused"
                    ? resumeRecording()
                    : pauseRecording();
                }}
                style={{ marginRight: "5px" }}
              >
                {status === "paused" ? (
                  <PlayArrow sx={{ color: "white" }} />
                ) : (
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor: "#f00"
                    }}
                  />
                )}
              </ButtonBase>
              <Timer status={status} />
              <Button
                variant='contained'
                onClick={handleRecord}
                sx={{ fontSize: "8px", height: "26px", background: "#037b4a" }}
              >
                <img src={CorrectIcon} width='15px' height='15px' alt='Done' />
                <div>Done</div>
              </Button>

              <IconButton onClick={handlecloseRecord}>
                <CloseIcon
                  sx={{
                    color: "white",
                    background: "#991402",
                    borderRadius: "7px"
                  }}
                />
              </IconButton>
            </div>
          )}

        {status === "stopped" && showRecordModal === true && (
          <div
            style={{
              background: "#211f3c",
              borderRadius: "14px",
              padding: "2px 3px 2px 8px"
            }}
          >
            <Button
              variant='contained'
              sx={{ fontSize: "10px", height: "26px", background: "#0568bf" }}
              onClick={handleStartRecording}
            >
              Start recording
            </Button>
            <IconButton onClick={handleClose}>
              <CloseIcon
                sx={{
                  color: "white",
                  background: "#991402",
                  borderRadius: "7px"
                }}
              />
            </IconButton>
          </div>
        )}
      </div>
    </div>
    </Portal>
  );
};
